module.exports = __webpack_public_path__ + "img/line-chart-down-01.1883ae59.svg";